// src/components/ComandaTicket.js
import React, { forwardRef } from 'react';

const ComandaTicket = forwardRef(({ pedido }, ref) => {
  if (!pedido) return null;

  return (
    <div ref={ref} style={{ 
  width: '58mm', 
  margin: '0 auto', 
  textAlign: 'center', 
  fontFamily: 'monospace',
  fontSize: '12px' }}>
      <div style={{ textAlign: 'center', marginBottom: '10px' }}>
        <strong>COMANDA</strong>
        <br />
        Mesa: {pedido.mesa_id}
        <br />
        Pedido #{pedido.pedido_id}
        <br />
        {new Date(pedido.created_at).toLocaleTimeString()}
        <hr />
      </div>

      {pedido.items.map((item, idx) => (
        <div key={idx} style={{ marginBottom: '5px' }}>
          <strong>{item.cantidad} x {item.nombre}</strong>
          {item.observacion && (
            <div style={{ fontSize: '10px' }}>({item.observacion})</div>
          )}
        </div>
      ))}

      <hr />
      <div style={{ textAlign: 'center' }}>
        Mozo: {pedido.mozo || 'N/A'}
      </div>
    </div>
  );
});

export default ComandaTicket;
